import { Pipe, PipeTransform } from '@angular/core';

import { ServiciosService } from '../../services/servicios.service';

@Pipe({
  name: 'obtenerItinerarioConfirmaciones'
})
export class ItinerarioConfirmacionesPipe implements PipeTransform { 
    constructor(private servicioService:ServiciosService){}

  transform(idServicio:any) {  
      return this.servicioService.obtenerServiciosPorPlantillaDeServicio(idServicio).valueChanges().take(1);
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/arreglo-confirmaciones.pipe.ts